
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicare-card-protector",
      function () {
        return require("private-next-pages/medicare-card-protector.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medicare-card-protector"])
      });
    }
  